import { createMiddleware } from "@tanstack/react-start";

/**
 * Replaces the generated `attachSupabaseAuth` middleware.
 *
 * The generated version imports the Supabase client at module scope, which pulls
 * the whole auth/realtime library into the main client bundle for every visitor —
 * even though this is a public marketing site where almost nobody is signed in.
 *
 * This version first checks localStorage for a persisted Supabase session and only
 * then dynamically imports the client to read a fresh access token.
 */
function hasPersistedSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith("sb-") && key.endsWith("-auth-token")) return true;
    }
  } catch {
    return false;
  }
  return false;
}

export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    if (!hasPersistedSession()) return next({ headers: {} });
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
  },
);
